export default [
  {
    permission: '@',
    title: '我的发票',
    sortOrder: 10,
    icon: 'el-icon-menu',
    url: '/my/invoice'
  }
]
